<template>
  <div>
    <div class="section-title">
      <h3>
        {{ i18n.cadastro.titulos.dadosPessoais }}
      </h3>
    </div>

    <el-row :gutter="16">
      <el-col :span="24">
        <el-form-item :label="i18n.cadastro.labels.nome" prop="pessoa.nome">
          <el-input v-model="value.nome"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :xs="24" :sm="12">
        <el-form-item
          :label="
            estrangeiro
              ? i18n.cadastro.labels.passaporte
              : i18n.cadastro.labels.cpf
          "
          :prop="estrangeiro ? 'pessoa.passaporte' : 'pessoa.cpf'"
        >
          <el-input
            v-if="!estrangeiro"
            key="cpf-input"
            v-model="value.cpf"
            v-mask="'###.###.###-##'"
          ></el-input>
          <el-input
            v-else
            key="passaporte-input"
            v-model="value.passaporte"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item
          :label="i18n.cadastro.labels.dataNascimento"
          prop="pessoa.dataNascimentoString"
        >
          <el-date-picker
            :key="`data-nascimento-${estrangeiro}`"
            v-model="dataNascimentoModel"
            type="date"
            :placeholder="i18n.cadastro.format.data"
            :format="estrangeiro ? 'yyyy-MM-dd' : 'dd/MM/yyyy'"
            value-format="yyyy-MM-dd"
            class="full-width"
            style="width: 100%"
            :picker-options="pickerOptionsDataNascimento"
            @change="onDataNascimentoChange"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :xs="24" :sm="12">
        <el-form-item
          :label="i18n.cadastro.labels.nomeMae"
          prop="pessoa.nomeMae"
        >
          <el-input v-model="value.nomeMae"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item :label="i18n.cadastro.labels.sexo" prop="pessoa.sexo">
          <el-select
            v-model="value.sexo"
            placeholder="Selecione"
            class="full-width"
          >
            <el-option
              :label="i18n.cadastro.dados.genero.masculino"
              value="MASCULINO"
            ></el-option>
            <el-option
              :label="i18n.cadastro.dados.genero.feminino"
              value="FEMININO"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="16" v-if="estrangeiro">
      <el-col :span="24">
        <el-form-item
          :label="i18n.cadastro.labels.nacionalidade"
          prop="pessoa.nacionalidade"
          required
        >
          <el-select
            v-model="value.nacionalidade"
            value-key="id"
            placeholder="Select Nationality"
            filterable
            class="full-width"
          >
            <el-option
              v-for="pais in paisesNacionalidade"
              :key="pais.id"
              :label="labelPais(pais)"
              :value="pais"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <div class="section-title">
      <h3>
        {{ i18n.cadastro.titulos.dadosContato }}
      </h3>
    </div>

    <el-row :gutter="16">
      <el-col :span="24">
        <el-form-item :label="i18n.cadastro.labels.email" prop="pessoa.email">
          <el-input
            v-model="value.email"
            type="email"
            autocomplete="email"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import {
  PT_CADASTRO,
  EN_CADASTRO
} from "@/utils/messages/interface/registrar/identificacao/cadastro";

export default {
  name: "DadosPessoaisForm",
  directives: { mask },
  props: {
    value: {
      type: Object,
      required: true
    },
    estrangeiro: {
      type: Boolean,
      default: false
    },
    paises: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    i18n() {
      return this.estrangeiro ? EN_CADASTRO : PT_CADASTRO;
    },
    paisesNacionalidade() {
      return (this.paises || []).filter(p => p && p.sigla !== "BR");
    },
    dataNascimentoModel: {
      get() {
        if (!this.value.dataNascimentoString) return null;

        try {
          if (this.value.dataNascimentoString.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return this.value.dataNascimentoString;
          }

          const parts = this.value.dataNascimentoString.split("/");
          if (parts.length === 3) {
            const [day, month, year] = parts;
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
          }
          return null;
        } catch (error) {
          return null;
        }
      },
      set(val) {
        if (!val) {
          this.value.dataNascimentoString = "";
          return;
        }

        // O componente retorna YYYY-MM-DD.
        // Convertemos sempre para DD/MM/YYYY para manter consistência com o backend.
        try {
          const [year, month, day] = val.split("-");
          this.value.dataNascimentoString = `${day}/${month}/${year}`;
        } catch (error) {
          this.value.dataNascimentoString = "";
        }
      }
    },
    pickerOptionsDataNascimento() {
      return {
        disabledDate: this.disableInvalidDates
      };
    }
  },
  methods: {
    labelPais(pais) {
      if (!pais) return "";
      return this.estrangeiro ? pais.nomeEn : pais.nomePt;
    },
    onDataNascimentoChange() {
      this.$emit("validate-field", "pessoa.dataNascimentoString");
    },
    disableInvalidDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const minDate = new Date();
      minDate.setFullYear(today.getFullYear() - 110);
      minDate.setHours(0, 0, 0, 0);

      // date vem do date-picker, também zera hora
      const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());

      return d < minDate || d > today;
    }
  }
};
</script>

<style scoped>
.section-title h3 {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 20px;
  margin-top: 30px;
  color: #295661;
}
.full-width {
  width: 100%;
}

@media (max-width: 767px) {
  .section-title h3 {
    font-size: 1rem;
    margin-top: 20px;
  }
}
</style>
